import React, { useState, useEffect, useRef } from "react";
import { useStoreSnackbar } from "../../store/snackbar";

import { FaUser } from "react-icons/fa";
import { FaLock } from "react-icons/fa";
import DatePicker from "react-datepicker";
import { FaCalendarAlt } from "react-icons/fa";
import {
  fileUrlUpload,
  getOtpRegister,
  summitRegisterData,
  getCourses,
  getSession,
  getStream,
  getAddressByPin,
} from "../../service/apiFetch";
import "react-datepicker/dist/react-datepicker.css";
import Link from "next/link";
import { data } from "autoprefixer";
// import { setItem } from "zustand-persist/lib/keeper";

export default function Register({ changeScreen }) {
  const [formErrors, setFormErrors] = useState({});
  const [errorOtp, setFormErrorsOtp] = useState({});
  const [otpId, setOtpId] = useState("");
  const otpRefs = useRef([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [token, setTokens] = useState(new Array(4).fill(""));
  const [allCourses, setAllCourse] = useState([]);
  const [allStreams, setAllStreams] = useState([]);
  const [streamId, setStreamId] = useState(null);
  const [streamLoading, setStreamLoading] = useState(false);
  const [loadingCourses, setLoadingCourses] = useState(false);
  const [pinCodeLoader, setPinCodeLoader] = useState(false);
  const [pinCodeDetail, setpinCodeDetail] = useState(null);
  const [pinCodeNotFoundError, setPinCodeNotFoundError] = useState("");
  const [postOfficeList, setPostOfficeList] = useState(null);
  const [addressList, setAddressList] = useState(null);
  const [loader, setLoader] = useState(false);
  const [allSession, setAllSession] = useState(false);
  const [checkedStatus, setCheckedStatus] = useState(false);
  const sessionId = useRef(null);
  const myOtp = useRef(null);
  const baseurl = process.env.NEXT_PUBLIC_API_BASE_URL;

  const [timer, setTimer] = useState(0); // seconds left
  const timerRef = useRef(null);

  const initialValue = {
    firstName: "",
    middleName: "",
    lastName: "",
    mobile: "",
    email: "",
    stream: "",
    course: "",
    session: "",
    personalImg: "",
    password: "",
    dob: null,
    gender: "",
    insty: "63c90b3e719643106c3aa1b6",
    center: "63c90b52462bb7110fe70a0f",
    address: {
      postalCode: "",
      address: "",
      landmark: "",
      city: "",
      state: "",
      country: "India",
      selectedPost: "",
      district: "",
    },
  };

  const [regisData, setRegisData] = useState(initialValue);
  const handleChange = (e) => {
    const { name, value } = e.target;

    // console.log("regist", regisData);

    if (
      name === "address" ||
      name === "landmark" ||
      name === "city" ||
      name === "district" ||
      name === "state" ||
      name === "postalCode" ||
      name === "postOffice"
    ) {
      setRegisData((prevData) => ({
        ...prevData,
        address: {
          ...prevData.address,
          [name]: value,
        },
      }));
    } else if (name === "dob") {
      const formattedDate =
        value instanceof Date ? value.toISOString().split("T")[0] : value; // Ensure value is formatted correctly
      setRegisData((prevData) => ({
        ...prevData,
        [name]: formattedDate,
      }));
    } else if (name === "fatherName") {
      setRegisData((prevData) => ({
        ...prevData,
        father: {
          ...prevData.father,
          name: value,
        },
      }));
    } else {
      setRegisData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleFileInput = (e) => {
    const { name, files } = e.target;
    const file = files[0];
    setRegisData({
      ...regisData,
      [name]: file,
    });
  };

  const isFile = (value) => {
    return value && typeof value === "object" && value instanceof File;
  };

  async function getFileUploadUrl(obj) {
    return new Promise(async (resolve, reject) => {
      let newObj = {};
      for (const key in obj) {
        if (isFile(obj[key])) {
          const fd = new FormData();
          fd.append("ekFile", obj[key], obj[key].name);
          const result = await fileUrlUpload(fd);
          if (result) {
            newObj[key] = result.url;
          } else {
            console.log(
              "Error in uploading file",
              result?.response?.details?.message
            );
            reject(result?.response?.details?.message);
          }
        } else {
          newObj[key] = obj[key];
        }
      }
      resolve(newObj);
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Object.keys(formErrors).length === 0) {
      try {
        const uploadedData = await getFileUploadUrl(regisData);
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
  };

  useEffect(() => {
    const fetchStream = async () => {
      let response = await getStream();
      if (response?.length) {
        setAllStreams(response);
      } else {
        console.log(
          "Failed to fetch Courses",
          response?.response?.details?.message
        );
      }
    };
    const fetchSession = async () => {
      setLoader(true);
      let response = await getSession();
      if (response?.length) {
        setAllSession(response);

        setLoader(false);
      } else {
        console.log("Failed to Session", response?.response?.details?.message);
        setLoader(false);
      }
    };
    fetchStream();
    fetchSession();
  }, []);

  useEffect(() => {
    const assignSession = async () => {
      for (let i = 0; i < allSession?.length; i++) {
        if (allSession[i]?.tag) {
          for (let t = 0; t < allSession[i]?.tag?.length; t++) {
            if (allSession[i]?.tag[t] == "WEB") {
              sessionId.current = allSession[i]?.id;
            }
          }
        }
      }
    };
    if (allSession?.length) {
      assignSession();
    }
    if (sessionId.current) {
      setRegisData((prevData) => ({
        ...prevData,
        session: sessionId.current,
      }));
    }
  }, [allSession]);

  const fetchCourse = async () => {
    try {
      setLoadingCourses(true);
      const param = new URLSearchParams({
        stream: streamId,
      });

      let result = await getCourses(param);

      if (result?.length) {
        setAllCourse(result);
      } else {
        console.log(
          "Error in Loading Course",
          result?.response?.details?.message
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingCourses(false);
    }
  };

  useEffect(() => {
    if (streamId) {
      setAllCourse([]);
      fetchCourse();
    }
  }, [streamId]);

  useEffect(() => {
    if (Object.keys(formErrors).length > 0) {
      const timer = setTimeout(() => {
        setFormErrors({});
      }, 5000);
      return () => clearTimeout(timer);
    }
    if (Object.keys(errorOtp).length > 0) {
      const timer = setTimeout(() => {
        setFormErrorsOtp({});
      }, 2000);
      return () => clearTimeout(timer);
    }
    if (pinCodeNotFoundError) {
      setpinCodeDetail(null);
    }

    setTimeout(() => {
      setPinCodeNotFoundError("");
    }, 2000);
  }, [formErrors, errorOtp, pinCodeNotFoundError]);

  async function getOtpRegis() {
    if (validate()) {
      setLoading(true);
      let data = { mobile: regisData.mobile };
      const result = await getOtpRegister(data);
      // console.log("otp response", result);
      if (result?.sent) {
        setOtpId(result.id);
        setLoading(false);
        generatePassword();
        useStoreSnackbar.getState().showSnackbar({
          description: "Successfully send otp",
          title: "Sent OTP",
          color: "success",
        });
        setPage(2);
        startTimer(60);
      } else {
        useStoreSnackbar.getState().showSnackbar({
          description: result?.response?.details?.message,
          title: result?.response?.details?.code,
          color: "error",
        });
        setLoading(false);
      }
    }
  }

  function startTimer(seconds) {
    setTimer(seconds);
    if (timerRef.current) clearInterval(timerRef.current);

    timerRef.current = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  }

  useEffect(() => {
    return () => clearInterval(timerRef.current); // cleanup on unmount
  }, []);

  const dataInFormate = (d) => {
    if (!d) return "";
    const [year, month, day] = d.split("-");
    return `${day}${month}${year}`;
  };

  async function Submit() {
    if (validateOtp()) {
      if (!regisData?.email) {
        const domain = baseurl.replace(/^https?:\/\//, ""); // remove http:// or https://
        regisData.email = regisData.mobile + "@" + domain;
      }
      let dataOtp = {
        id: otpId,
        otp: myOtp.current,
        password: dataInFormate(regisData.dob),
        username: regisData.mobile,
      };

      const nameArray = regisData.firstName
        .split(" ")
        .filter((item) => item != null && String(item).trim() !== "");
      const [fName, ...oName] = nameArray;
      let mName, lName;
      if (oName.length > 1) {
        [mName, ...lName] = oName;
      } else {
        lName = oName;
      }
      lName = lName.join(" ");

      const convertedFilestudent = await getFileUploadUrl(regisData);

      dataOtp.student = {
        ...convertedFilestudent,
        firstName: fName,
        middleName: mName,
        lastName: lName,
        password: dataOtp.password,
      };
      setLoading(true);

      const result = await summitRegisterData(dataOtp);
      localStorage.setItem(
        result?.user?.id,
        JSON.stringify({
          address: {
            billingAddress: regisData?.address,
            shippingAddress: regisData?.address,
          },
        })
      );

      if (result?.token) {
        useStoreSnackbar.getState().showSnackbar({
          description: " You have registered successfully",
          title: "Successfully Registered",
          color: "success",
        });
        setLoading(false);
        setPage(3);
      } else {
        useStoreSnackbar.getState().showSnackbar({
          description: result?.response?.details?.message,
          title: result?.response?.details?.code,
          color: "error",
        });
        setLoading(false);
      }
    }
  }

  useEffect(() => {
    if (
      regisData?.address?.postalCode &&
      regisData?.address?.postalCode.length === 6
    ) {
      fetchAddressByPinCode(regisData.address.postalCode);
    } else {
      setpinCodeDetail(null);
      setPostOfficeList(null);
      setRegisData((prevData) => ({
        ...prevData,
        address: {
          ...prevData.address,
          // postOffice: "",
          city: "",
          district: "",
          state: "",
        },
      }));
    }
  }, [regisData?.address?.postalCode]);

  const fetchAddressByPinCode = async (pinCode) => {
    try {
      setPinCodeLoader(true);
      const result = await getAddressByPin(pinCode);

      if (!result?.error) {
        setpinCodeDetail(result);
      } else {
        setPinCodeNotFoundError(result?.details?.error);
      }

      // if (result.error) {
      //   // console.log("Error", result?.Message);
      //   setPinCodeNotFoundError(result?.details?.error);
      // }
    } catch (err) {
      console.log("Failed to Address through PinCode", err);
    } finally {
      setPinCodeLoader(false);
    }
  };

  useEffect(() => {
    if (pinCodeDetail?.PostOffice?.length) {
      let list = pinCodeDetail.PostOffice.map((el) => el?.Name);
      let posts = [...new Set(list)];
      setPostOfficeList(posts);
    }
  }, [pinCodeDetail?.PostOffice]);

  useEffect(() => {
    if (regisData?.address?.postOffice) {
      let list = pinCodeDetail.PostOffice.find(
        (el) => el?.Name === regisData?.address?.postOffice
      );
      setAddressList(list);
    }
  }, [pinCodeDetail?.PostOffice, regisData?.address?.postOffice]);

  useEffect(() => {
    if (addressList?.Block && addressList?.District && addressList?.State) {
      setRegisData((prevData) => ({
        ...prevData,
        address: {
          ...prevData.address,
          city: addressList.Block,
          district: addressList.District,
          state: addressList.State,
        },
      }));
    }
  }, [addressList]);

  async function backStep() {
    setPage((prevPage) => prevPage - 1);
  }
  async function generatePassword() {
    const length = 6;
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let generatedPassword = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      generatedPassword += charset[randomIndex];
    }
    return generatedPassword;
  }

  const validate = () => {
    const errors = {};

    if (!regisData.firstName) {
      errors.firstName = "First Name is required.";
    } else if (!/^[a-zA-Z\s]+$/.test(regisData.firstName)) {
      errors.firstName = "Name must only contain letters.";
    }
    // else if (regisData.firstName.length > 20) {
    //   errors.firstName = "First Name cannot exceed 20 characters.";
    // }
    if (!regisData.course) {
      errors.course = "Course is required.";
    }

    if (!regisData.stream) {
      errors.stream = "Stream is required.";
    }

    if (!regisData.session) {
      errors.session = "Session is required.";
    }
    if (!regisData.mobile) {
      errors.mobile = "Mobile Number is required.";
    } else if (!/^\d+$/.test(regisData.mobile)) {
      errors.mobile = "Mobile Number must be numeric.";
    } else if (regisData.mobile.length !== 10) {
      errors.mobile = "Mobile Number must be of 10 digits.";
    }

    // if (!regisData.dob) {
    //   errors.dob = "Date of birth is required";
    // }

    if (!regisData.dob) {
      errors.dob = "Date of birth is required";
    } else {
      // YYYY-MM-DD format
      const dobRegex = /^(19|20)\d\d-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;

      if (!dobRegex.test(regisData.dob)) {
        errors.dob = "Invalid date format (YYYY-MM-DD)";
      } else {
        const dobDate = new Date(regisData.dob);
        const today = new Date();

        if (dobDate >= today) {
          errors.dob = "Date of birth must be in the past";
        }
      }
    }

    if (!regisData.gender) {
      errors.gender = "Gender is required";
    }
    if (!regisData?.address?.selectedPost) {
      errors.selectedPost = "Select postal Area is required";
    }
    if (!regisData?.address?.address) {
      errors.address = "Address is required";
    }

    if (!regisData?.address?.city) {
      errors.city = "City is required";
    }

    if (!regisData?.address?.state) {
      errors.state = "State is required";
    }
    if (!regisData?.address?.landmark) {
      errors.landmark = "Landmark is required";
    }
    if (!regisData?.address?.district) {
      errors.district = "District is required";
    }

    if (!regisData?.address?.postalCode) {
      errors.postalCode = "Postal Code  is required";
    } else if (!/^\d+$/.test(regisData?.address?.postalCode)) {
      errors.postalCode = "Postal Code  must be numeric.";
    } else if (regisData?.address?.postalCode.length !== 6) {
      errors.postalCode = "Postal Code must be of 6 digits.";
    }

    // alert("Some fields required or invalid !!.");
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateOtp = () => {
    const errors = {};
    if (!myOtp?.current) {
      errors.myOtp = "Otp is required";
    } else if (!/^\d+$/.test(myOtp?.current)) {
      errors.myOtp = "Otp must be numeric.";
    } else if (myOtp?.current.length !== 4) {
      errors.myOtp = "Otp must be of 4 digits.";
    }
    setFormErrorsOtp(errors);
    return Object.keys(errors).length === 0;
  };

  const handleTokenChange = (e, index) => {
    const value = e.target.value;
    if (/^\d$/.test(value) || value === "") {
      let newToken = [...token];
      newToken[index] = value;
      setTokens(newToken);
    }
  };

  if (token?.length) {
    myOtp.current = token.join("");
  }
  if (loader) {
    return (
      <div className="animate-pulse px-4 py-6">
        <div className="grid md:grid-cols-2 gap-4">
          {[1,2,3,4,5,6].map(i => (
            <div key={i} className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-1/3" />
              <div className="h-10 bg-gray-200 rounded-lg" />
            </div>
          ))}
        </div>
        <div className="mt-4 h-10 bg-gray-200 rounded-lg w-32" />
      </div>
    );
  }

  return (
    <section id="register" className="my-register">
      <div className="">
        <div className="grid grid-rows">
          <div className="grid grid-cols-12">
            <div className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
              {loading ? (
                <div className="flex justify-center items-center min-h-[10rem]">
                  <div className="border-gray-100 border-t-blue-500 w-[60px] h-[60px] animate-spin rounded-[50%] border-8 border-solid"></div>
                </div>
              ) : (
                <div className="">
                  <form onSubmit={handleSubmit}>
                    {page === 1 ? (
                      <div className="rounded-[8px]   shadow-[0_8px_6px_-1px_rgba(0,0,0,0.2),0_8px_8px_0_rgba(0,0,0,0.14),0_8px_8px_0_rgba(0,0,0,0.12)] pb-[1rem]">
                        {/* <div className="rounded-t-[8px] font-semibold text-[18px] sm:text-[24px] gap-[8px] flex items-center py-4  px-3 justify-center bg-white  mb-2 sticky z-[20]  w-full left-0 -top-4 ">
                          <FaUser />
                         Registration Form
                        </div> */}
                        <div className="px-[10px] sm:px-4  mx-4 my-2 pt-1 pb-4">
                          <div className="mb-2 flex gap-2 text-sm font-semibold items-center bg-[#EEFBFF] px-3 py-2 rounded-lg">
                            <FaUser className="text-[#052c24]" /> <span className="text-[#052c24]">Personal Details</span>
                          </div>
                          <div className="text-[#000000de]">
                            <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
                              <div>
                                <label
                                  htmlFor="firstName"
                                  className="text-[15px] font-bold mb-1 flex gap-[2px]"
                                >
                                  Full Name
                                  <span className="text-red-500">*</span>
                                </label>
                                <input
                                  name="firstName"
                                  type="text"
                                  placeholder="Full Name"
                                  className="w-full w-full border border-[#052c24] py-[8px] px-[10px] outline-none rounded-[8px] text-sm focus:shadow-[0_0_0_2px_#FFD338] transition-all"
                                  value={regisData.firstName}
                                  onChange={handleChange}
                                />
                                {formErrors?.firstName && (
                                  <p className="text-[red] text-[15px]">
                                    {formErrors.firstName}
                                  </p>
                                )}
                              </div>

                              <div className="">
                                <label
                                  htmlFor="mobile"
                                  className="text-[15px] font-bold mb-1 flex gap-[2px]"
                                >
                                  Mobile Number
                                  <span className="text-red-500">*</span>
                                </label>
                                {/* <input
                                  name="mobile"
                                  type="text"
                                  placeholder="Mobile Number"
                                  className="w-full w-full border border-[#052c24] py-[8px] px-[10px] outline-none rounded-[8px] text-sm focus:shadow-[0_0_0_2px_#FFD338] transition-all"
                                  value={regisData.mobile}
                                  onChange={handleChange}
                                  keyfilter="num"
                                /> */}
                                <input
                                  name="mobile"
                                  type="tel"
                                  placeholder="Mobile Number"
                                  maxLength={10} // 👈 max 10 characters
                                  pattern="[0-9]{10}" // 👈 regex: exactly 10 digits
                                  className="w-full w-full border border-[#052c24] py-[8px] px-[10px] outline-none rounded-[8px] text-sm focus:shadow-[0_0_0_2px_#FFD338] transition-all"
                                  value={regisData.mobile}
                                  onChange={handleChange}
                                />
                                {formErrors?.mobile && (
                                  <p className="text-[red] text-[15px]">
                                    {formErrors.mobile}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="grid md:grid-cols-2 grid-cols-1 gap-2 mt-4">
                              <div className="mt-[10px]">
                                <label
                                  htmlFor="stream"
                                  className="text-[15px] mb-1 font-bold flex gap-[2px]"
                                >
                                  Stream
                                  <span className="text-red-500">*</span>
                                </label>
                                <select
                                  name="stream"
                                  className="w-full w-full border border-[#052c24] py-[8px] px-[10px] outline-none rounded-[8px] text-sm focus:shadow-[0_0_0_2px_#FFD338] transition-all"
                                  value={regisData.stream}
                                  // onChange={handleChange}
                                  onChange={(e) => {
                                    handleChange(e); // pass the event to your handler
                                    setStreamId(e.target.value); // get selected value

                                    setRegisData((prev) => ({
                                      ...prev,
                                      course: "",
                                    }));

                                    // ✅ clear old courses
                                    setAllCourse([]);
                                  }}
                                >
                                  {allStreams?.length ? (
                                    <>
                                      <option value="">Select Stream *</option>
                                      {allStreams.map((item, index) => (
                                        <option key={index} value={item.id}>
                                          {item.valueAlias}
                                          {/* {setStreamId(item.id)} */}
                                        </option>
                                      ))}
                                    </>
                                  ) : streamLoading ? (
                                    <option value="">Loading......</option>
                                  ) : (
                                    <option value="">Load Stream </option>
                                  )}
                                </select>
                                {formErrors.stream && (
                                  <p className="text-red-500">
                                    {formErrors.stream}
                                  </p>
                                )}
                              </div>
                              <div className="mt-[10px]">
                                <label
                                  htmlFor="course"
                                  className="text-[15px] mb-1 font-bold flex gap-[2px]"
                                >
                                  Course
                                  <span className="text-red-500">*</span>
                                </label>

                                <select
                                  name="course"
                                  className="w-full w-full border border-[#052c24] py-[8px] px-[10px] outline-none rounded-[8px] text-sm focus:shadow-[0_0_0_2px_#FFD338] transition-all"
                                  value={regisData.course || ""}
                                  onChange={handleChange}
                                  disabled={!regisData.stream}
                                >
                                  <option value="">Select Course *</option>

                                  {loadingCourses ? (
                                    <option value="">Loading...</option>
                                  ) : allCourses.length > 0 ? (
                                    allCourses.map((item) => (
                                      <option key={item.id} value={item.id}>
                                        {item.valueAlias}
                                      </option>
                                    ))
                                  ) : (
                                    <option value="">Course not found</option>
                                  )}
                                </select>

                                {formErrors.course && (
                                  <p className="text-red-500">
                                    {formErrors.course}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="grid md:grid-cols-2 grid-cols-1 mt-4 gap-2">
                              <div className="mt-[10px]">
                                <label
                                  htmlFor="session"
                                  className="text-[15px] mb-1 font-bold flex gap-[2px]"
                                >
                                  Session
                                  <span className="text-red-500">*</span>
                                </label>
                                <select
                                  name="session"
                                  className="w-full w-full border border-[#052c24] py-[8px] px-[10px] outline-none rounded-[8px] text-sm focus:shadow-[0_0_0_2px_#FFD338] transition-all"
                                  value={regisData.session}
                                  onChange={handleChange}
                                >
                                  <option value="" disabled>
                                    Select session *
                                  </option>

                                  {allSession.length > 0 &&
                                    allSession.map((item, index) => (
                                      <option key={index} value={item.id}>
                                        {item.name}
                                      </option>
                                    ))}
                                </select>

                                {formErrors.session && (
                                  <p className="text-red-500">
                                    {formErrors.session}
                                  </p>
                                )}
                              </div>

                              <div className="mt-[10px]">
                                <label
                                  htmlFor="dob"
                                  className="text-[15px] mb-1 font-bold flex gap-[2px]"
                                >
                                  Date of Birth{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <DatePicker
                                  selected={
                                    regisData.dob
                                      ? new Date(regisData.dob)
                                      : null
                                  }
                                  onChange={(date) =>
                                    handleChange({
                                      target: { name: "dob", value: date },
                                    })
                                  }
                                  customInput={
                                    <div
                                      className="custom-date-input"
                                      style={{ position: "relative" }}
                                    >
                                      <input
                                        name="dob"
                                        className="dob w-full w-full border border-[#052c24] py-[8px] px-[10px] outline-none rounded-[8px] text-sm focus:shadow-[0_0_0_2px_#FFD338] transition-all"
                                        placeholder="Select your date of birth"
                                        value={regisData.dob || ""}
                                        readOnly
                                      />
                                      <FaCalendarAlt
                                        style={{
                                          position: "absolute",
                                          right: "10px",
                                          top: "50%",
                                          transform: "translateY(-50%)",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          document.querySelector(".dob").focus()
                                        }
                                      />
                                    </div>
                                  }
                                  dateFormat="yyyy-MM-dd"
                                  showYearDropdown
                                  showMonthDropdown
                                  dropdownMode="select"
                                />
                                {formErrors?.dob && (
                                  <p className="text-[red] text-[15px]">
                                    {formErrors.dob}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="grid md:grid-cols-2 mt-4 grid-cols-1 gap-2">
                              <div className="mt-[10px]">
                                <label
                                  htmlFor="gender"
                                  className="text-[15px] mb-1 font-bold flex gap-[2px]"
                                >
                                  Gender
                                  <span className="text-red-500">*</span>
                                </label>
                                <select
                                  name="gender"
                                  value={regisData.gender}
                                  onChange={(e) =>
                                    handleChange({
                                      target: {
                                        name: e.target.name,
                                        value: e.target.value,
                                      },
                                    })
                                  }
                                  className="w-full w-full border border-[#052c24] py-[8px] px-[10px] outline-none rounded-[8px] text-sm focus:shadow-[0_0_0_2px_#FFD338] transition-all"
                                >
                                  <option value="">Select Gender</option>
                                  <option value="M">Male</option>
                                  <option value="F">Female</option>
                                </select>
                                {formErrors?.gender && (
                                  <p className="text-[red] text-[15px]">
                                    {formErrors.gender}
                                  </p>
                                )}
                              </div>

                              <div className="mt-[10px]">
                                <label
                                  htmlFor="postalCode"
                                  className="text-[15px] mb-1 font-bold flex gap-[2px]"
                                >
                                  PostalCode
                                  <span className="text-red-500">*</span>
                                </label>

                                {/* <input
                                  name="postalCode"
                                  type="number"
                                  placeholder="Enter Postal Code"
                                  className="w-full w-full border border-[#052c24] py-[8px] px-[10px] outline-none rounded-[8px] text-sm focus:shadow-[0_0_0_2px_#FFD338] transition-all"
                                  value={regisData.address.postalCode}
                                  onChange={handleChange}
                                  maxLength={6}
                                /> */}

                                <input
                                  name="postalCode"
                                  type="number"
                                  placeholder="Enter Postal Code"
                                  className="w-full w-full border border-[#052c24] py-[8px] px-[10px] outline-none rounded-[8px] text-sm focus:shadow-[0_0_0_2px_#FFD338] transition-all"
                                  value={regisData.address.postalCode}
                                  onChange={(e) => {
                                    let value = e.target.value;
                                    value = value.replace(/\D/g, "");
                                    if (value.length > 6) {
                                      value = value.slice(0, 6);
                                    }

                                    handleChange({
                                      target: { name: "postalCode", value },
                                    });
                                  }}
                                />
                                {pinCodeNotFoundError && (
                                  <p className="text-[red] text-[15px]">
                                    {pinCodeNotFoundError}
                                  </p>
                                )}
                                {formErrors?.postalCode && (
                                  <p className="text-[red] text-[15px]">
                                    {formErrors.postalCode}
                                  </p>
                                )}
                              </div>

                              {pinCodeLoader ? (
                                <div className="flex justify-center items-center py-4">
                                  <div className="w-8 h-8 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                                </div>
                              ) : (
                                <>
                                  {pinCodeDetail?.length > 0 && (
                                    <div className="mt-[10px]">
                                      <label
                                        htmlFor="gender"
                                        className="text-[15px] mb-1 font-bold flex gap-[2px]"
                                      >
                                        Postal Area
                                        <p className="p-0 m-0 text-red-500">
                                          *
                                        </p>
                                      </label>
                                      <select
                                        name="selectedPost"
                                        value={regisData.address.selectedPost}
                                        onChange={(e) => {
                                          const selected = pinCodeDetail.find(
                                            (item) =>
                                              item.Name === e.target.value
                                          );
                                          handleChange({
                                            target: {
                                              name: e.target.name,
                                              value: e.target.value,
                                            },
                                          });
                                          if (selected) {
                                            setRegisData((prev) => ({
                                              ...prev,
                                              address: {
                                                ...prev.address,
                                                selectedPost: e.target.value,
                                                city: selected.Block,
                                                landmark: selected.Name, // city = Name
                                                district: selected.District,
                                                state: selected.State,
                                                postalCode: selected.Pincode,
                                              },
                                            }));
                                          }
                                        }}
                                        className="w-full w-full border border-[#052c24] py-[8px] px-[10px] outline-none rounded-[8px] text-sm focus:shadow-[0_0_0_2px_#FFD338] transition-all"
                                      >
                                        <option value="">
                                          Select Postal Area
                                        </option>
                                        {pinCodeDetail.map((postalName) => (
                                          <option value={postalName.Name}>
                                            {postalName.Name}
                                          </option>
                                        ))}
                                      </select>
                                      {formErrors?.selectedPost && (
                                        <p className="text-[red] text-[15px]">
                                          {formErrors.selectedPost}
                                        </p>
                                      )}
                                    </div>
                                  )}
                                </>
                              )}
                            </div>

                            <div className="mt-[16px]">
                              <label
                                htmlFor="address"
                                className="text-[15px] mb-1 font-bold flex gap-[2px]"
                              >
                                Address
                                <span className="text-red-500">*</span>
                              </label>

                              <textarea
                                name="address"
                                rows={2}
                                type="text"
                                placeholder="Enter Full Address"
                                className="w-full border border-[#052c24] py-[8px] px-[10px] outline-none rounded-[8px] text-sm focus:shadow-[0_0_0_2px_#FFD338] transition-all placeholder:text-gray-400"
                                value={regisData.address.address}
                                onChange={handleChange}
                              />
                              {formErrors?.address && (
                                <p className="text-[red] text-[15px]">
                                  {formErrors.address}
                                </p>
                              )}
                            </div>

                            <div className="grid md:grid-cols-2 grid-cols-1 gap-2 mt-4">
                              <div className="mt-[10px]">
                                <label
                                  htmlFor="state"
                                  className="text-[15px] mb-1 font-bold flex gap-[2px]"
                                >
                                  Landmark
                                  <span className="text-red-500">*</span>
                                </label>

                                <input
                                  name="landmark"
                                  type="text"
                                  placeholder="Enter Landmark"
                                  className="w-full w-full border border-[#052c24] py-[8px] px-[10px] outline-none rounded-[8px] text-sm focus:shadow-[0_0_0_2px_#FFD338] transition-all"
                                  value={regisData.address.landmark}
                                  onChange={handleChange}
                                />

                                {formErrors?.landmark && (
                                  <p className="text-[red] text-[15px]">
                                    {formErrors.landmark}
                                  </p>
                                )}
                              </div>

                              <div className="mt-[10px]">
                                <label
                                  htmlFor="city"
                                  className="text-[15px] mb-1 font-bold flex gap-[2px]"
                                >
                                  City <span className="text-red-500">*</span>
                                </label>
                                <input
                                  name="city"
                                  type="text"
                                  placeholder="Enter City"
                                  className="w-full w-full border border-[#052c24] py-[8px] px-[10px] outline-none rounded-[8px] text-sm focus:shadow-[0_0_0_2px_#FFD338] transition-all"
                                  value={regisData.address.city}
                                  onChange={handleChange}
                                />
                                {formErrors.city && (
                                  <p className="text-red-500">
                                    {formErrors.city}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="grid md:grid-cols-2 grid-cols-1 gap-2 mt-4">
                              <div className="mt-[10px]">
                                <label
                                  htmlFor="city"
                                  className="text-[15px] mb-1 font-bold flex gap-[2px]"
                                >
                                  District
                                  <span className="text-red-500">*</span>
                                </label>
                                <input
                                  name="district"
                                  type="text"
                                  placeholder="Enter District"
                                  className="w-full w-full border border-[#052c24] py-[8px] px-[10px] outline-none rounded-[8px] text-sm focus:shadow-[0_0_0_2px_#FFD338] transition-all"
                                  value={regisData.address.district}
                                  onChange={handleChange}
                                />
                                {formErrors.district && (
                                  <p className="text-red-500">
                                    {formErrors.district}
                                  </p>
                                )}
                              </div>

                              <div className="mt-[10px]">
                                <label
                                  htmlFor="state"
                                  className="text-[15px] mb-1 font-bold flex gap-[2px]"
                                >
                                  State
                                  <span className="text-red-500">*</span>
                                </label>

                                <input
                                  name="state"
                                  type="text"
                                  placeholder="Enter State"
                                  className="w-full w-full border border-[#052c24] py-[8px] px-[10px] outline-none rounded-[8px] text-sm focus:shadow-[0_0_0_2px_#FFD338] transition-all"
                                  value={regisData.address.state}
                                  onChange={handleChange}
                                  disabled={!!regisData.address.state}
                                />

                                {formErrors?.state && (
                                  <p className="text-[red] text-[15px]">
                                    {formErrors.state}
                                  </p>
                                )}
                              </div>
                            </div>

                            {pinCodeLoader && (
                              <div className="flex justify-start items-center h-[3rem] mt-[10px]">
                                <div className="border-gray-100 border-t-blue-500 w-[40px] h-[40px] animate-spin rounded-[50%] border-4 border-solid "></div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className=" px-[10px] sm:px-8  flex flex-wrap md:justify-between justify-center gap-4 mt-4 mb-6">
                          <div>
                            <button
                              className="block my-button cursor-pointer"
                              onClick={getOtpRegis}
                              type="submit"
                            >
                              Submit
                            </button>
                          </div>
                          <div>
                            <div className="flex justify-center  items-center gap-2 ">
                              <span>Already Registered ?</span>
                              <button
                                type="button"
                                onClick={() => changeScreen("LOGIN")}
                                className="block mx-auto text-[#fac401] font-medium underline text-lg cursor-pointer"
                              >
                                Log In
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : page === 2 ? (
                      <div className="rounded-[8px] shadow-[0_8px_6px_-1px_rgba(0,0,0,0.2),0_8px_8px_0_rgba(0,0,0,0.14),0_8px_8px_0_rgba(0,0,0,0.12)] pb-[1rem]">
                        <div className="rounded-t-[8px] mt-4 text-[18px] sm:text-[23px] gap-[8px] flex items-center py-3 px-3 justify-center bg-[#EEFBFF] mb-5">
                          <FaLock className="text-[#052c24]" />
                          <h3 className="text-[#052c24]">Enter OTP</h3>
                        </div>
                        <div className="px-[10px] sm:px-4 ">
                          <div>
                            <div className="otpCard flex gap-[10px] justify-center">
                              {token.map((value, index) => (
                                <div key={index} className="w-[60px]">
                                  <input
                                    className="border border-[#052c24] rounded-[8px] bg-transparent outline-none w-full text-center py-2 text-lg font-semibold focus:shadow-[0_0_0_2px_#FFD338] transition-all"
                                    value={value}
                                    onChange={(e) =>
                                      handleTokenChange(e, index)
                                    }
                                    maxLength={1}
                                    aria-label={`OTP Digit ${index + 1}`}
                                    ref={(input) =>
                                      (otpRefs.current[index] = input)
                                    }
                                    onKeyUp={(e) => {
                                      if (
                                        e.target.value.length === 1 &&
                                        index < token.length - 1
                                      ) {
                                        otpRefs.current[index + 1]?.focus();
                                      } else if (
                                        e.key === "Backspace" &&
                                        index > 0
                                      ) {
                                        otpRefs.current[index - 1]?.focus();
                                      }
                                    }}
                                  />
                                </div>
                              ))}
                            </div>

                            {errorOtp?.myOtp && (
                              <p className="text-[red] mt-[4px] text-[15px] text-center">
                                {errorOtp.myOtp}
                              </p>
                            )}
                          </div>

                          <div className="my-3 pb-[1rem] flex justify-center gap-[1rem]">
                            <div>
                              <button
                                onClick={Submit}
                                type="submit"
                                className="my-button cursor-pointer"
                              >
                                Verify Otp
                              </button>
                            </div>
                            <div>
                              {timer > 0 ? (
                                <button
                                  disabled
                                  className="bg-gray-200 text-gray-500 font-medium px-6 py-2 rounded-lg shadow-sm cursor-not-allowed transition-all duration-200"
                                >
                                  Resend OTP in {timer}s
                                </button>
                              ) : (
                                <button
                                  onClick={getOtpRegis}
                                  disabled={loading}
                                  className={`${
                                    loading
                                      ? "bg-gray-300 text-gray-500 cursor-wait"
                                      : "bg-[#052c24] hover:bg-[#034435] text-white"
                                  }  px-6 py-1 shadow-[0px_4px_10px_rgba(0,0,0,0.3)] border border-[#052c24] rounded-xl text-lg font-medium transition-colors`}
                                >
                                  {loading ? "Sending..." : "Resend OTP"}
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : page === 3 ? (
                      <div className="rounded-[8px] shadow-[0_8px_6px_-1px_rgba(0,0,0,0.2),0_8px_8px_0_rgba(0,0,0,0.14),0_8px_8px_0_rgba(0,0,0,0.12)] pb-[1rem]">
                        <div className=" text-[18px] sm:text-[23px] gap-[8px] flex items-center py-3 px-3 justify-center bg-[var(--bg-color)] text-[#000000] mb-5">
                          <h3>Registered Successfully</h3>
                        </div>
                        <div className="px-[10px] sm:px-4">
                          <p>
                            Registration was successful! Login details have been
                            sent to your registered mobile number.
                          </p>
                          <div className="mt-3  pb-[1rem]">
                            <button
                              type="button"
                              className="bg-[#FFD338] px-6 py-1 shadow-[0px_4px_10px_rgba(0,0,0,0.3)] border border-black rounded-xl text-lg font-medium text-gray-900 transition-colors"
                              onClick={() => changeScreen("LOGIN")}
                            >
                              Login
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="px-4">
                        <p>Page Not Found</p>
                      </div>
                    )}
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
